import { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { TutorDisplayProps } from 'types/displayTypes'
import { getStudentPhotoPath } from 'utils/profiles'

import { ProfileCardCompact } from './ProfileCardCompact'

// Refactor styles and copied code from Single and DoubleTutor
const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
    },
  }),
  { name: 'FiveTutor' }
)

export const FiveTutor = (props: TutorDisplayProps) => {
  const classes = useStyles(props)
  const { profiles } = props

  return (
    <div className={classes.root}>
      {profiles?.map((profile, index) => {
        return <ProfileCardCompact key={index} profile={profile} size="small" />
      })}
    </div>
  )
}